import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { CostCenterConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { CostCenterService } from './api/costCenter.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class CostCenterApiModule {
    public static forRoot(configurationFactory: () => CostCenterConfiguration): ModuleWithProviders<CostCenterApiModule> {
        return {
            ngModule: CostCenterApiModule,
            providers: [ { provide: CostCenterConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: CostCenterApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('CostCenterApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
